module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-filter', {
    attrs: {
      "is-disabled": _vm.isDisabled
    },
    on: {
      "change": _vm.emitHandler
    }
  }, _vm._l((_vm.organizations), function(organization) {
    return _c('option', {
      key: organization.id,
      domProps: {
        "value": organization.id,
        "selected": organization.id === _vm.organizationId
      }
    }, [_vm._v("\n    " + _vm._s(organization.name) + "\n  ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a4abfae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/filters/OrganizationFilter.vue
// module id = 1849
// module chunks = 0